const {
  findImage,
  serializeImages
} = require('../utils/entities');

class Category {
  /*:: static fromJson: (Object) => Category */

  /*:: static serialize: (Category) => Object */
  constructor({
    /*: {
        id: ?string,
        name: ?string,
        shortName: ?string,
        iconLarge: ?string,
        iconSmall: ?string,
        parentId?: ?string
      }*/

    id,
    name,
    shortName,
    iconLarge,
    iconSmall,
    parentId
  } = {}) {
    this.id = id;
    this.name = name;
    this.shortName = shortName;
    this.iconLarge = iconLarge;
    this.iconSmall = iconSmall;
    this.parentId = parentId; // TODO: This assumption only works with a two-level hierarchy
    // However, it's the same assumption the backend uses right now
    // If we ever go to a more complicated hierarchy, the API will need to return this field

    this.isLeaf = !!this.parentId;
  }

}

Category.fromJson = json => {
  const {
    images
  } = json;
  return new Category({
    id: json.id,
    name: json.name,
    shortName: json.shortName,
    iconLarge: findImage(images, 'category-icon-large'),
    iconSmall: findImage(images, 'category-icon-small'),
    parentId: json.parentCategoryId
  });
};

Category.serialize = (category
/*: Category*/
) => (
/*: Object*/
{
  id: category.id,
  name: category.name,
  shortName: category.shortName,
  images: serializeImages([category.iconLarge, category.iconSmall]),
  parentCategoryId: category.parentId
});

module.exports = Category;